import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ConditionalWrapper } from '@uswitch/spark.utils';
import { BiChevronLeft, BiChevronRight, BiFirstPage, BiLastPage } from '@uswitch/spark-icons/bi';
import PropTypes from 'prop-types';
import { usePaginationContext } from './context';
import { PaginationLink } from './link';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var Icon = function Icon(_ref) {
  var variant = _ref.variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '100%' : _ref$size,
      props = _objectWithoutProperties(_ref, ["variant", "size"]);

  switch (variant) {
    case 'first':
      return _jsx(BiFirstPage, _objectSpread({
        size: size
      }, props));

    case 'last':
      return _jsx(BiLastPage, _objectSpread({
        size: size
      }, props));

    case 'previous':
      return _jsx(BiChevronLeft, _objectSpread({
        size: size
      }, props));

    case 'next':
      return _jsx(BiChevronRight, _objectSpread({
        size: size
      }, props));

    default:
      return null;
  }
};

export var PaginationArrow = function PaginationArrow(_ref2) {
  var variant = _ref2.variant,
      disabled = _ref2.disabled;
  var ctx = usePaginationContext();
  var targetPageNumber = ctx[variant];
  var pageUrl = ctx.createPageUrl(targetPageNumber);
  return _jsx(ConditionalWrapper, {
    condition: !disabled,
    wrapper: function wrapper(_ref3) {
      var children = _ref3.children;
      return _jsx(PaginationLink, {
        to: pageUrl,
        children: children
      });
    },
    children: _jsx(Icon, _objectSpread({
      variant: variant
    }, disabled && {
      color: '#D3D3D3',
      sx: {
        height: 32,
        width: 32,
        mr: variant !== 'last' && 20
      }
    }))
  });
};
PaginationArrow.propTypes = {
  variant: PropTypes.oneOf(['first', 'last', 'previous', 'next']),
  disabled: PropTypes.bool
};
PaginationArrow.defaultProps = {
  variant: 'first',
  disabled: false
};